// Shared by Modal, ConfirmDialog and Moo. A fixed body also prevents iOS background
// scrolling; only the final overlay restores the original styles and page position.
let count = 0;
let restore: (() => void) | undefined;
export function lockBodyScroll(): () => void {
  if (count === 0) {
    const { scrollX, scrollY, innerWidth } = window;
    const body = document.body;
    const keys = ["overflow", "position", "top", "left", "width", "paddingRight"] as const;
    const styles = keys.map(key => [key, body.style[key]] as const);
    const gutter = innerWidth - document.documentElement.clientWidth;
    const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
    Object.assign(body.style, { overflow: "hidden", position: "fixed", top: `${-scrollY}px`, left: `${-scrollX}px`, width: "100%" });
    if (gutter > 0) body.style.paddingRight = `${padding + gutter}px`;
    restore = () => {
      for (const [key, value] of styles) body.style[key] = value;
      window.scrollTo(scrollX, scrollY);
    };
  }
  count++;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--count === 0) { restore?.(); restore = undefined; }
  };
}
